<template>
  <fidelio :hotel="hotel" v-if="hotel.SoftwareId==13" @close="$emit('close')"></fidelio>
  <elektraWeb :hotel="hotel" v-if="hotel.SoftwareId==6" @close="$emit('close')"></elektraWeb>
</template>

<script>
import fidelio from "./fidelio.vue";
import elektraWeb from "./elektraWeb.vue";
export default {
  name:"tempReservation",
  props:{
    hotel:{
      type:Object,
      default:null
    }
  },
  components:{
    fidelio,
    elektraWeb
  }
}
</script>

<style>

</style>